<!-- src/App.vue -->
<template>
  <div style="width: 99vw; height: 97.5vh;">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
// 在 Vue 2 中，通常不需要显式导入 RouterView
export default {
  name: 'MarkdownEditorApp',
}
</script>